// extracted by mini-css-extract-plugin
export var container = "styles-module__container___NyahI";
export var checkboxAndFiletype = "styles-module__checkboxAndFiletype___CLEVO";
export var fileType = "styles-module__fileType___dHQAF";
export var fileName = "styles-module__fileName___cLchp";
export var fileSize = "styles-module__fileSize___VD1Q8";
export var fileInformation = "styles-module__fileInformation___FwQZF";
export var metaData = "styles-module__metaData___CvguS";
export var controls = "styles-module__controls___kaQ5i";
export var removeButton = "styles-module__removeButton___ETVGu";
export var labelClassName = "styles-module__labelClassName___BqViM";
export var successUpload = "styles-module__successUpload___nvQFh";